import { QueryClient, useQuery } from '@tanstack/react-query';
import { GeolocationApi } from 'v5/api/geolocation/geolocation.api';
import { z } from 'zod';
import { createLocalStorageApi } from '../../../platform/ts/localStorageApi';
import { ErrorService } from '../../front/ErrorService/ErrorService';
import { GeolocationService } from './GeolocationService';

const recentPlacesApi = createLocalStorageApi(
  'recent-geolocation-search',
  z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      description: z.string().optional()
    })
  ).parse,
  []
);

export function createGeolocationService(
  queryClient: QueryClient,
  api: GeolocationApi,
  errorService: ErrorService
): GeolocationService {
  const search = errorService
    .withCategory('GeolocationService')
    .wrap(api.search);
  return {
    useLocations: query_ => {
      const query = query_?.trim() ?? '';

      return useQuery(
        {
          queryKey: ['geolocation', query],
          queryFn: async () => {
            if (!query) {
              return recentPlacesApi.load();
            }
            const results = await search(query);
            if (results.length > 0) {
              recentPlacesApi.save(results);
            }
            return results;
          }
        },
        queryClient
      );
    }
  };
}
